import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取warehouseIn
export function warehouseInList(jobUuid) {
  return request({
    url: URL.seaExport.warehouseIn,
    method: 'get',
    params: { jobUuid }
  })
}
// 货物信息解除
export function warehouseInUnLock(uuid) {
  return request({
    url: URL.seaExport.warehouseInUnLock,
    method: 'get',
    params: { uuid }
  })
}

// 自动配货
export function autoAllocateCargo(jobUuid) {
  return request({
    url: URL.seaExport.autoAllocateCargo,
    method: 'get',
    params: { jobUuid }
  })
}

// 自动配货(外部接口)
export function externalAutoAllocate(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.externalAutoAllocate,
    method: 'post',
    data
  })
}

// 自动配货
export function complexQuery(data) {
  return request({
    url: URL.seaExport.complexQuery,
    method: 'post',
    data
  })
}

// 仓库信息更新
export function updateWarehuse(data) {
  return request({
    url: URL.seaExport.warehouseIn,
    method: 'put',
    data
  })
}
// 前端手动装箱
export function uploadPhotoData(data) {
  return request({
    url: URL.seaExport.uploadPhotoData,
    method: 'post',
    data
  })
}

// 空运出口-保存仓库信息
export function saveWarehouseInForAe(data) {
  return request({
    url: URL.warehouseIn.saveWarehouseInForAe,
    method: 'post',
    data
  })
}

// 删除进仓单- 空运出口专用
export function delWarehouseInForAe(params) {
  return request({
    url: URL.warehouseIn.delWarehouseInForAe,
    method: 'delete',
    params: params
  })
}

// 批量仓库信息更新
export function batchWarehuseIn(data) {
  return request({
    url: URL.seaExport.batchWarehuseIn,
    method: 'put',
    data
  })
}
// 前端批量手动装箱
export function batchUploadPhotoData(data) {
  return request({
    url: URL.seaExport.batchUploadPhotoData,
    method: 'post',
    data
  })
}
